export const roles = ["customer", "support", "editor", "manager", "admin"];
